<template>
  <div class="ls-plate-component">
    <PersonCenter v-if="role==='student'" />

    <div
      class="plate-item-wrap"
      v-for="item in plateConfig"
      :key="item.areaId"
      :class="hasShadow(item)"
    >
      <template v-if="item.areaType.includes('readArea')">
        <!-- 阅读区特殊排序规则，独立渲染 -->
        <div class="read-area-plate" :style="readAreaPlateStyle(item.subassemblys)">
          <div v-if="!item.hiddenTitle" class="plate-title-cell" :style="getPlateTitleBg.center"><!--  :style="getBgImg(item)" -->
            <img :src="getPlateTitleBg.top" alt="">
            <div class="hidden-cell">
              <span class="title">{{ item.areaTitle }}</span>
            </div>
            <img :src="getPlateTitleBg.bottom" alt="">
          </div>
          <template v-for="(moduleItem, index) in item.subassemblys">
            <div v-if="index < 8" :key="moduleItem.id" class="module-item">
              <div
                v-if="moduleItem.moduleShapeType == 'horizontalRectangle'"
                class="horizontal-rectangle-module"
              >
                <img class="img" :src="moduleItem.logoUrl" />
                <span class="title">{{ getSubassemblyTitle(moduleItem) }}</span>
              </div>
            </div>
          </template>
          <!-- 查看全部 -->
          <div class="checkAll flex justify-center pl-[5px]" v-if="item.subassemblys.length > 8">
            <img class="img" src="https://cdnws.51tyty.com/lstyty/file/2024/05/24/e53b7e93cb2db220dc7ede877e89ef0c.png" alt="">
          </div>
        </div>
      </template>
      <template v-else>
        <div v-if="!item.hiddenTitle" class="plate-title-cell" :style="getPlateTitleBg.center"><!--  :style="getBgImg(item)" -->
          <img :src="getPlateTitleBg.top" alt="">
          <div class="hidden-cell">
            <span class="title">{{ item.areaTitle }}</span>
          </div>
          <img :src="getPlateTitleBg.bottom" alt="">
        </div>
        <template v-for="(moduleItem, index) in item.subassemblys">
          <div
            v-if="index < 8 || item.areaType == 'courseLearn'"
            :key="moduleItem.id"
            class="module-item"
            v-show="!(moduleItem.moduleShapeType === 'horizontalMiniRectangle'||moduleItem.moduleShapeType === 'achievement')"
            :class="moduleItem.moduleShapeType">
            <!-- 背景图课表 -->
            <div
              v-if="moduleItem.moduleShapeType == 'verticalTableRectangle'"
              class="vertical-table-rectangle-module"
            >
              <img
                class="img"
                src="https://cdnws.51tyty.com/lstyty/file/2023/10/12/7d7d1b70a9b27aca7f36f5dea042e51b.png"
              />
            </div>
            <!-- 个人秀场 -->
            <div
              v-if="moduleItem.moduleShapeType == 'personShow'"
              class="works-module"
            >
              <img class="img" :src="moduleItem.logoUrl" />
            </div>

            <!-- mini横长方形组件 -->
            <!-- <div
              v-if="moduleItem.moduleShapeType == 'horizontalMiniRectangle'"
              class="horizontal-mini-rectangle-module"
            >
              <img class="icon" :src="moduleItem.logoUrl" />
              <span class="title">{{ getSubassemblyTitle(moduleItem) }}</span>
            </div> -->
            <!-- 大竖长方形组件 -->
            <div
              v-if="moduleItem.moduleShapeType == 'verticalBigRectangle'"
              class="vertical-big-rectangle-module"
            >
              <img class="img" :src="moduleItem.logoUrl" />
              <span v-if="moduleItem.moduleActionType != 'v2_stu_memorizeWords'" class="title">{{ getSubassemblyTitle(moduleItem) }}</span>
              <img
                v-if="moduleItem.moduleActionType != 'v2_stu_memorizeWords'"
                class="time"
                src="https://cdnws.51tyty.com/lstyty/file/2023/09/22/473c9f553d48eff2eefeb9ccc96f6614.png"
                alt=""
              />
              <img
                v-else
                class="memorizeWordsBtn"
                src="https://cdnws.51tyty.com/lstyty/file/2024/11/11/f1828ff8a67dbf2694879bec0edea86e.png"
                alt=""
              />
            </div>
            <!-- 横长方形组件 -->
            <div
              v-if="moduleItem.moduleShapeType == 'horizontalRectangle'"
              class="horizontal-rectangle-module"
            >
              <img class="img" :src="moduleItem.logoUrl" />
              <span class="title">{{ getSubassemblyTitle(moduleItem) }}</span>
            </div>
            <!-- 小竖长方形组件 -->
            <div
              v-if="moduleItem.moduleShapeType == 'verticalMinRectangle'"
              class="vertical-min-rectangle-module"
            >
              <img class="img" :src="moduleItem.logoUrl" />
              <span class="title">{{ getSubassemblyTitle(moduleItem) }}</span>
            </div>
            <!-- 正方形组件 -->
            <div
              v-if="moduleItem.moduleShapeType == 'square'"
              class="square-module"
            >
              <img class="icon" :src="moduleItem.logoUrl" />
              <span class="title">{{ getSubassemblyTitle(moduleItem) }}</span>
            </div>
            <!-- 竖长方形组件 -->
            <div
              v-if="moduleItem.moduleShapeType == 'verticalRectangle'"
              class="vertical-rectangle-module"
            >
              <img class="img" :src="moduleItem.logoUrl" />
              <span class="title">{{ getSubassemblyTitle(moduleItem) }}</span>
            </div>
            <!-- 中横长方形 -->
            <div
              v-if="moduleItem.moduleShapeType == 'horizontalMiddleRectangle'"
              class="horizontal-middle-rectangle-module"
            >
              <img class="img" :src="moduleItem.logoUrl" />
              <span class="title">{{ getSubassemblyTitle(moduleItem) }}</span>
            </div>
            <!-- 小横长方形 -->
            <div
              v-if="moduleItem.moduleShapeType == 'horizontalMinRectangle'"
              class="horizontal-min-rectangle-module"
              :class="[getHorizontalRectangleModuleClass(item, moduleItem),getHorizontalRectangleModuleClassTwo(item, moduleItem)]"
            >
              <img class="img" :src="moduleItem.logoUrl" />
              <span class="title">{{ getSubassemblyTitle(moduleItem) }}</span>
            </div>
            <!-- 同步学 -->
            <div
              v-if="moduleItem.moduleShapeType == 'syncStudy'"
              class="sync-study-module"
            >
              <img class="img" :src="moduleItem.logoUrl" />
            </div>
            <!-- 成长足迹 -->
            <div
              v-if="moduleItem.moduleShapeType == 'stu_growthFootprint'"
              class="stu-growth-footprint-module"
            >
              <img class="img" :src="moduleItem.logoUrl" />
            </div>
            <!-- 个人中心 -->
            <div
              v-if="moduleItem.moduleShapeType == 'userInfo'"
              class="user-info-module"
            >
              <img class="img" :src="moduleItem.logoUrl" />
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import PersonCenter from './PersonCenter.vue'
import { useInstStore } from '@/stores/inst'


export default {
  props: {
    plateConfig: {
      type: Array,
      default: () => {
        return [];
      }
    },
    role: {
      type: String
    }
  },
  components:{
    PersonCenter
  },
  data() {
    return {};
  },
  computed: {
    // 板块名称背景图
    getPlateTitleBg() {
      const instStore = useInstStore()
      if (instStore.subject == 'english') {
        // 英语学科特殊标签背景图
        return {
          top: 'https://cdnws.51tyty.com/lstyty/file/2024/04/07/b0e2ac871dbeadefdfbca973ddb3ca4f.png',
          center: `background-image: url('https://cdnws.51tyty.com/lstyty/file/2024/04/07/44184227954800b5522c708fe7cf5473.png')`,
          bottom: 'https://cdnws.51tyty.com/lstyty/file/2024/04/07/029e1847c45e83d930757d3a6db21624.png',
        }
      } else if(instStore.subject == 'sinology') {
        // 国学
        return {
          top: 'https://cdnws.51tyty.com/lstyty/file/2024/04/07/370ab244737d7bf00dec83f56d4f3102.png',
          center: `background-image: url('https://cdnws.51tyty.com/lstyty/file/2024/04/07/963e4d4c21f0b6aebf671d3c996015c5.png')`,
          bottom: 'https://cdnws.51tyty.com/lstyty/file/2024/04/07/c38642895362826d6bf9a32b1de36433.png',
        }
      } else if(instStore.subject == 'art') {
        // 美术
        return {
          top: 'https://cdnws.51tyty.com/lstyty/file/2024/04/07/c958e6d125ba236d012635080263c7b6.png',
          center: `background-image: url('https://cdnws.51tyty.com/lstyty/file/2024/04/07/06618c5261d7b318002088fe1753f3f5.png')`,
          bottom: 'https://cdnws.51tyty.com/lstyty/file/2024/04/07/79e515ae2af77dd42d800bacdc61a4bf.png',
        }
      } else if(instStore.subject == 'calligraphy') {
        // 书法
        return {
          top: 'https://cdnws.51tyty.com/lstyty/file/2024/04/07/8f406fcb2bbec744bbe871dced652b4b.png',
          center: `background-image: url('https://cdnws.51tyty.com/lstyty/file/2024/04/07/ce6132ccfda2d3bc02b1feab719d70c4.png')`,
          bottom: 'https://cdnws.51tyty.com/lstyty/file/2024/04/07/1e89962e170d761eaaf061d11dc27e40.png',
        }
      } else if(instStore.subject == 'drama') {
        // 戏剧
        return {
          top: 'https://cdnws.51tyty.com/lstyty/file/2024/04/07/b4ffb93bde64431358266cafb34f7429.png',
          center: `background-image: url('https://cdnws.51tyty.com/lstyty/file/2024/04/07/f0bf9dc7477e870b3d68d1054354370b.png')`,
          bottom: 'https://cdnws.51tyty.com/lstyty/file/2024/04/07/0062fd72905ce555140447f9872e265e.png',
        }
      } else {
        return {
          top: 'https://cdnws.51tyty.com/lstyty/file/2024/04/07/8ce7935e73f2e6d782d9cd38c1ca7086.png',
          center: `background-image: url('https://cdnws.51tyty.com/lstyty/file/2024/04/07/a686a83e10464b0d0c3dd72d25c66189.png')`,
          bottom: 'https://cdnws.51tyty.com/lstyty/file/2024/04/07/16635fa69cb7dbf12f29f48b45ccf144.png',
        }
      }
    },
  },
  watch: {
    plateConfig: function(val) {
      this.$forceUpdate();
    }
  },
  methods: {
    getBgImg(data) {
      const instStore = useInstStore()
      let url = "";
      if (instStore.subject == 'english') {
        // 英语学科特殊标签背景图
        url = 'https://cdnws.51tyty.com/lstyty/file/2024/03/12/b95457b2ef93a652e5fdf488650a399f.png'
      } else {
        if (['courseLearn', 'teachCenter', 'tea_teachCenter', 'manage_teachCenter'].includes(data.areaType)) {
          // 绿色
          url = 'https://cdnws.51tyty.com/lstyty/file/2023/08/23/d6ed75f6c9e0eeabb8941c1eb8ce4787.png'
        } else if (['extracurricularLearn', 'manageCenter', 'eduAffairsCenter', 'stu_growthFootprint'].includes(data.areaType)) {
          // 紫色
          url = 'https://cdnws.51tyty.com/lstyty/file/2023/08/27/468ab1c4cd6ac111d53df0a927e2c112.png'
        } else if (['personShow', 'materialManager', 'manage_materialManager', 'tea_materialManager', 'marketCenter', 'syncStudy'].includes(data.areaType)) {
          // 蓝色
          url = 'https://cdnws.51tyty.com/lstyty/file/2023/08/27/cea5f04cffa81562ffbc8de62e8f7d55.png'
        } else if (['tea_study_tools', 'manage_study_tools'].includes(data.areaType)) {
          // 橘色
          url = 'https://cdnws.51tyty.com/lstyty/file/2024/01/04/cbba085b8bb167a3028ac5f50e85a1a5.png'
        } else if (['stu_expandMaterial', 'tea_expandMaterial', 'manage_expandMaterial'].includes(data.areaType)) {
          // 橙色
          url = 'https://cdnws.51tyty.com/lstyty/file/2023/09/01/965e841769f2f14133e5e61b560ecc75.png'
        } else if (['expandLearn', 'tea_expandLearn', 'manage_expandLearn'].includes(data.areaType)) {
          // 淡紫色
          url = 'https://cdnws.51tyty.com/lstyty/file/2023/09/01/c7d69d4b611f2ac454be73fb9bde6cb3.png'
        }
      }
      return {
        "background-image": `url(${url})`
      };
    },
    getSubassemblyTitle(data) {
      return data.subassemblyTitle && data.subassemblyTitle[0].title;
    },
    itemVisible(data) {
      if (!data.hasOwnProperty("subassemblyTitle")) {
        return false;
      }
      if (data.hasHide == "true") {
        return false;
      } else {
        return true;
      }
    },
    plateItemVisible(data) {
      if (!data.hasOwnProperty("subassemblys")) {
        return false;
      }
      if (this.role == "student" && data.areaType == "courseLearn") {
        return true;
      } else if (data.subassemblys <= 0) {
        return false;
      } else {
        let result = data.subassemblys.find(item => {
          return item.hasHide == "false";
        });
        if (result) {
          return true;
        } else {
          return false;
        }
      }
    },
    getHorizontalRectangleModuleClass(plate, subassembly) {
      // tea_materialManager, manage_materialManager, marketCenter
      // 以上三种类型需要根据数量展示不同的大小
      const areaType = plate.areaType
      let horizontalMinRectangleArr = plate.subassemblys.filter(m => m.moduleShapeType == 'horizontalMinRectangle')
      let totality = horizontalMinRectangleArr.length
      let nowIndex = horizontalMinRectangleArr.findIndex(m => m.id == subassembly.id) + 1
      // 教材管理、
      // 板块内不同数量的组件需要不同方式的渲染
      // UI设计稿如下
      // https://lanhuapp.com/web/#/item/project/detailDetach?tid=6d8f5209-6fe5-472c-85b6-a9fc0cef7bec&pid=a44f6f43-cba6-4bc5-8137-2d3ca5a1b5a2&project_id=a44f6f43-cba6-4bc5-8137-2d3ca5a1b5a2&image_id=42a7c153-36c5-481a-a67e-ad927bbc25cb&fromEditor=true&type=set
      const arr = ['tea_materialManager', 'manage_materialManager', 'marketCenter']
      if (arr.includes(areaType)) {
        return this.moduleClass(totality,nowIndex);
      }
      return ''
    },

    // 版块下某些模块需要根据数量展示不同大小
    getHorizontalRectangleModuleClassTwo(plate, subassembly) {
      const areaType = plate.areaType
      let arr = [{
        areaType: 'tea_teachCenter',
        list: ['v2_mySchedule','v2_member_period','v2_course_progress','v2_classRollCall']
      },{
        areaType: 'manage_teachCenter',
        list: ['v2_mySchedule','v2_member_period','v2_course_progress','v2_classRollCall']
      },{
        areaType: 'manage_taskCenter',
        list: ['v2_assignTask','v2_checkTask','v2_quick_review']
      },{
        areaType: 'tea_taskCenter',
        list: ['v2_assignTask','v2_checkTask','v2_quick_review']
      }];
      let list = arr.filter(i => i.areaType == areaType).length > 0 ? arr.filter(i => i.areaType == areaType)[0].list : [];
      let horizontalMinRectangleArr = plate.subassemblys.filter(m => list.includes(m.moduleActionType))
      let totality = horizontalMinRectangleArr.length
      let nowIndex = horizontalMinRectangleArr.findIndex(m => m.id == subassembly.id) + 1
      if (list.includes(subassembly.moduleActionType)) {
        return this.moduleClass(totality,nowIndex);
      }
      return ''
    },
    // 根据数量展示不同样式的类名
    moduleClass(totality,nowIndex) {
      if (totality <= 2) {
        return 'big_horizontal_rectangle'
      } else if (totality <= 3) {
        return 'middle_horizontal_rectangle'
      } else if (totality <= 4) {
        return 'small_horizontal_rectangle'
      } else if (totality <= 5) {
        if (nowIndex <= 2) {
          return 'big_horizontal_rectangle'
        } else {
          return 'middle_horizontal_rectangle'
        }
      } else if (totality <= 6) {
        return 'middle_horizontal_rectangle'
      } else if (totality <= 7) {
        if (nowIndex <= 3) {
          return 'middle_horizontal_rectangle'
        } else {
          return 'small_horizontal_rectangle'
        }
      } else {
        return 'small_horizontal_rectangle'
      }
    },
    hasShadow(data) {
      let style = ''
      if (!data.hiddenShadow) {
        style = 'has-shadow'
      }
      if (!data.hiddenTitle) {
        style += ' has-title'
      }
      return style
    },
    readAreaPlateStyle(data) {
      let length = data.length
      let baseWidth = 135
      let width = 0
      let marginRight = 0
      if (length <= 2) {
        width = baseWidth * 1
      } else if (length <= 4) {
        width = baseWidth * 2
      } else if (length <= 6) {
        width = baseWidth * 3
      } else if (length <= 8) {
        width = baseWidth * 4
      } else if (length >= 8) {
        width = baseWidth * 4
      }
      if (length > 8) {
        marginRight = 20
      }
      return { width: `${width}px`, marginRight: `${marginRight}px`, }
    }
  }
};
</script>

<style lang="less" scoped>
.ls-plate-component {
  flex: 1;
  margin: 0 35px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 10px;
  .plate-item-wrap {
    border-radius: 10px;
    height: 267px;
    position: relative;
    writing-mode: vertical-lr;
    margin-left: 10px;

    .plate-title-cell {
      width: 35px;
      min-height: 80px;
      /* max-height: 130px; */
      position: absolute;
      left: -17px;
      top: -5px;
      background-size: 100% calc(100% - 36px);
      background-position: center;
      background-repeat: no-repeat;
      padding: 18px 0 19px 5px;
      overflow: hidden;
      .hidden-cell {
        min-height: 50px;
        /* max-height: 80px; */
        background-size: 100% 100%;
        overflow: hidden;
        text-align: center;
      }
      img{
        position: absolute;
        width: inherit;
        height: auto;
        object-fit: contain;
        &:first-child {
          top: 0;
          left: 0;
        }
        &:last-child{
          bottom: 1px;
          left: 0;
        }
      }
      .title {
        writing-mode: vertical-lr;
        letter-spacing: 4px;
        font-size: 12px;
        color: #fff;
        white-space: nowrap;
        display: inline-block;
        // transform: scale(0.8);
        // margin-top: -5px;
      }
    }

    .module-item {
      display: inline-block;
      writing-mode: horizontal-tb;
      width: fit-content;
      margin-right: 10px;
      margin-bottom: 10px;
      .achievement-module {
        height: 98px;
        width: 98px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .horizontal-mini-rectangle-module {
        height: 40px;
        width: 105px;
        background: rgba(255, 255, 255, 0.7);
        box-shadow: inset 0px 0px 7px 2px rgba(255, 255, 255, 0.6);
        border-radius: 7px;
        backdrop-filter: blur(16px);
        display: flex;
        flex-direction: row;
        align-items: center;
        .icon {
          width: 38px;
          height: 38px;
          margin: 0 0 0 6px;
        }
        .title {
          flex: 1;
          display: inline-block;
          font-size: 12px;
          color: #333;
          text-align: center;
          // transform: scale(0.8);
        }
      }
      .vertical-big-rectangle-module {
        width: 155px;
        height: 240px;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        .img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 10px;
        }
        .title {
          font-size: 19px;
          color: #fff;
          display: inline-block;
          position: absolute;
          top: 17px;
          left: 0;
          width: 100%;
          text-align: center;
          text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 17px;
        }
        .time {
          position: absolute;
          bottom: 20px;
          left: calc(50% - 70px);
          width: 140px;
        }
        .memorizeWordsBtn {
          position: absolute;
          bottom: 15px;
          left: calc(50% - 50px);
          width: 100px;
        }
      }
      .vertical-table-rectangle-module {
        width: 225px;
        height: 241px;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        .img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
          // object-fit: cover;
        }
      }
      .horizontal-rectangle-module {
        width: 124px;
        height: 115px;
        background: #ffffff;
        border-radius: 10px;
        .img {
          width: 100%;
          height: 93px;
          object-fit: cover;
          border-radius: 7px;
        }
        .title {
          font-size: 14px;
          color: #333;
          display: inline-block;
          width: 100%;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .works-module {
        width: 450px;
        height: 240px;
        border-radius: 10px;
        overflow: hidden;
        .img {
          width: 100%;
          height: calc(100%);
        }
      }

      .vertical-min-rectangle-module {
        width: 80px;
        height: 115px;
        border-radius: 10px;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        .img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
        .title {
          font-size: 14px;
          color: #fff;
          display: inline-block;
          position: absolute;
          bottom: 12px;
          left: 0;
          width: 100%;
          text-align: center;
          text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.4);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 5px;
        }
      }
      .square-module {
        width: 65px;
        height: 72px;
        background: rgba(255, 255, 255, 0.7);
        box-shadow: inset 0px 0px 7px 2px rgba(255, 255, 255, 0.6);
        border-radius: 7px;
        backdrop-filter: blur(16px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .icon {
          width: 43px;
          height: 43px;
        }
        .title {
          display: inline-block;
          font-size: 12px;
          color: #333;
          text-align: center;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 2px;
        }
      }
      .vertical-rectangle-module {
        height: 240px;
        width: 115px;
        border-radius: 10px;
        position: relative;
        .img {
          width: 100%;
          height: calc(100%);
          object-fit: cover;
          border-radius: 10px;
        }
        .title {
          position: absolute;
          left: 0;
          font-size: 18px;
          bottom: 20px;
          display: inline-block;
          width: 100%;
          color: #fff;
          text-align: center;
          text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 10px;
        }
      }
      .horizontal-middle-rectangle-module {
        width: 130px;
        height: 100px;
        border-radius: 10px;
        position: relative;
        display: flex;
        align-items: center;
        .img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
        .title {
          position: absolute;
          display: block;
          width: 70px;
          right: 0;
          text-align: center;
          font-size: 12px;
        }
      }
      .horizontal-min-rectangle-module {
        height: 52px;
        width: 123px;
        border-radius: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;
        overflow: hidden;
        .img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .title {
          display: inline-block;
          font-size: 13px;
          width: 65px;
          text-align: center;
          color: #fff;
          text-align: center;
          position: absolute;
          right: 0;
          margin: 0 5px 0 2px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box !important;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      .horizontal-min-rectangle-module.big_horizontal_rectangle {
        height: 115px;
      }
      .horizontal-min-rectangle-module.middle_horizontal_rectangle {
        height: 73px;
      }
      .horizontal-min-rectangle-module.small_horizontal_rectangle {
        height: 52px;
      }
      .sync-study-module {
        width: 160px;
        height: 240px;
        border-radius: 10px;
        overflow: hidden;
        .img {
          width: 100%;
          height: calc(100%);
        }
      }
      .stu-growth-footprint-module {
        width: 260px;
        height: 240px;
        border-radius: 10px;
        overflow: hidden;
        .img {
          width: 100%;
          height: calc(100%);
        }
      }
      .user-info-module {
        width: 160px;
        height: 265px;
        border-radius: 10px;
        overflow: hidden;
        .img {
          width: 100%;
          height: calc(100%);
        }
      }
    }
    .module-item.horizontalMiniRectangle {
      margin-bottom: 5px;
    }
    .module-item.square {
      margin-bottom: 11px;
    }
    .module-item.userInfo {
      margin-right: 0;
    }
    .checkAll{
      height: 240px;
      width: 26px;
      margin-left: -3px;
      .img {
        width: 16px;
        height: auto;
      }
    }

    .read-area-plate {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      writing-mode: horizontal-tb;

      .hidden-cell {
        writing-mode: vertical-lr;
      }
      .checkAll{
        position: absolute;
        right: 10px;
        top: 80px;
        height: 105px;
        width: 25px;
        .img {
          width: 16px;
          height: auto;
        }
      }
    }
  }
  .has-shadow {
    padding: 13.5px 7px 0px 15px;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: inset 0px 0px 7px 2px rgba(255,255,255,0.6);
    backdrop-filter: blur(10px);
  }
  .has-title {
    margin-left: 35px;
  }
}
</style>
